import { Row } from "antd";

export default function RowCosto({ children }) {
  return (
    <Row gutter={[10, 10]} style={{ marginBottom: 10 }}>
      {children}
    </Row>
  );
}
